'use client';

import { useTheme } from './ThemeProvider';
import {
  SunIcon,
  MoonIcon,
  ComputerDesktopIcon,
} from '@heroicons/react/24/outline';

interface ThemeSwitcherProps {
  variant?: 'flex' | 'grid';
  className?: string;
}

export default function ThemeSwitcher({ variant = 'flex', className = '' }: ThemeSwitcherProps) {
  const { theme, setTheme } = useTheme();

  const themeOptions = [
    { value: 'light' as const, label: 'Light', icon: SunIcon },
    { value: 'dark' as const, label: 'Dark', icon: MoonIcon },
    { value: 'system' as const, label: 'System', icon: ComputerDesktopIcon },
  ];

  const containerClasses = variant === 'grid'
    ? 'grid grid-cols-3 gap-1 bg-[var(--color-background)] p-1 rounded-lg'
    : 'inline-flex h-[34px] items-center bg-[var(--color-surface)] border border-[var(--color-border)] p-0.5 rounded-lg shadow-sm';

  const buttonClasses = variant === 'grid'
    ? 'flex flex-col items-center justify-center p-2 rounded-md transition-all'
    : 'flex h-full items-center justify-center px-2 rounded-md transition-all';

  return (
    <div className={`${containerClasses} ${className}`}>
      {themeOptions.map((option) => {
        const Icon = option.icon;
        const isActive = theme === option.value;
        return (
          <button
            key={option.value}
            onClick={() => setTheme(option.value)}
            className={`${buttonClasses} ${
              isActive
                ? 'bg-[var(--color-surface)] shadow-sm text-[var(--color-accent)]'
                : 'text-[var(--color-text-secondary)] hover:text-[var(--color-text-primary)]'
            }`}
            title={option.label}
          >
            <Icon className="w-5 h-5" />
          </button>
        );
      })}
    </div>
  );
}
